<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>手机注册</span>
      <img
        :src="`${$cdnLink}/wanXin/orangeTheme/fanhui.png`"
        :class="$style.fanhui"
        @click="$emit('back')"
      />
    </header>
    <main>
      <div :class="$style.accountWrap">
        <div :class="$style.inputWrap">
          <img :src="`${$cdnLink}/wanXin/orangeTheme/shoujihao.png`" :class="$style.leftIcon" />
          <input type="text" placeholder="请输入要注册的手机号" v-model.trim="form.tel_num" />
        </div>
      </div>
      <div :class="[$style.inputWrap, $style.pwd]">
        <img :src="`${$cdnLink}/wanXin/orangeTheme/mima.png`" :class="$style.leftIcon" />
        <input type="text" placeholder="6~18位字母、数字、下划线" v-model.trim="form.password" />
      </div>
      <div :class="[$style.inputWrap, $style.code]">
        <img :src="`${$cdnLink}/wanXin/orangeTheme/yanzhengma.png`" :class="$style.leftIcon" />
        <input type="text" placeholder="请输入验证码" v-model.trim="form.smsCode" />
        <span :class="$style.getCode" @click="getVerifyCode" v-if="!count">获取</span>
        <span :class="$style.getCode" v-else>{{ count }}</span>
      </div>
      <button :class="$style.submitBtn" @click="toRegister">一键注册</button>
      <div :class="$style.agree">
        <img
          @click="tocheck"
          :src="agreement ? `${$cdnLink}/wanXin/orangeTheme/xuanzhong.png` : `${$cdnLink}/wanXin/orangeTheme/weixuanzhong.png`"
          alt
        />
        <span>我已阅读并接受<span  @click="redirectArgument(0, 2)">《用户服务协议》</span>和<span @click="redirectArgument(1, 2)">《用户隐私协议》</span></span>
      </div>
    </main>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getVerifyCode as getVerifyCodeApi } from "@/api/user";
import moment from "moment";
import CountDown from '@/mixins/countDown';
import CryptoJS from "crypto-js";
import { regexpVerify } from "@/libs/business/account";
import { Toast } from "vant";
import isFullScreen from '@/libs/business/fullScreen'

export default {
  data() {
    return {
      fullScreen: '',
      form: {},
      agreement: false, // 是否同意协议
    }
  },
  mixins: [CountDown],
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {

  },
  computed: {
    ...mapState({
      device_id: state => state.user.device_info.uuid,
      appkey: state => state.user.appkey
    })
  },
  methods: {
    tocheck() {
      this.agreement = !this.agreement;
    },
    redirectArgument(type, source) {
      this.$emit("redirectArgument", type, source);
    },
    async getVerifyCode() {
      const { tel_num } = this.form;
      const time = moment().unix();
      await regexpVerify(this.form, [
        { key: "tel_num", hint: "请输入正确的手机号", type: "phone" },
      ]);
      const sign = CryptoJS.MD5(
        CryptoJS.MD5(this.device_id + time + tel_num) +
        this.device_id +
        time +
        tel_num
      ).toString();

      await getVerifyCodeApi({
        tel_num,
        time: moment().unix(),
        sign,
        device_id: this.device_id,
        jh_app_id: this.appkey,
      });
      Toast("发送成功");
      this.setTimer();
    },
    async toRegister() {
      await regexpVerify(this.form, [
        { key: 'tel_num', hint: '请输入正确的手机号', type: 'phone' },
        { key: 'password', hint: '请输入正确的密码' },
        { key: 'smsCode', hint: '请输入正确的验证码' }
      ]);
      if (!this.agreement) {
        this.$toast('请先同意用户服务协议');
        return;
      }
      localStorage.setItem('agreement_flag', 1);
      this.$emit('register', this.form);
    }
  }
}
</script>
<style lang="scss" module>
@import "../../assets/css/common.scss";

.wrap {
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding-top: 0.28rem;
    .accountWrap {
      position: relative;
    }
    .inputWrap {
      @include common-inputWrap();
      justify-content: flex-start;
      padding-left: 0.25rem;
      .leftIcon {
        margin-right: 0.16rem;
      }
      &.pwd {
        margin-top: 0.12rem;
        margin-bottom: 0.12rem;
        > input {
          width: 3.5rem;
        }
      }
      &.code {
        margin-bottom: 0.28rem;
        > input {
          width: 2.6rem;
        }
        .getCode {
          display: flex;
          align-items: center;
          color: $primary-color;
          border-left: 1px solid $primary-color;
          padding-left: 0.2rem;
          height: 0.5rem;
          font-size: $font-nm-1;
        }
      }
    }
    .redirect {
      display: flex;
      color: $primary-color-1;
      justify-content: space-between;
      width: 4.44rem;
      margin: auto;
      font-size: $font-nm-1;
      > span {
        padding: 0.12rem 0.22rem 0.22rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .submitBtn {
      @include common-button();
    }
    .agree {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.2rem;
      color: #999999;
      margin-top: 0.16rem;
      > img {
        width: 0.17rem;
        height: 0.17rem;
        margin-right: 0.1rem;
        margin-top: 0.02rem;
      }
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding-top: 13px;
      .accountWrap {
        position: relative;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        justify-content: flex-start;
        padding-left: 12px;
        .leftIcon {
          margin-right: 8px;
        }
        &.pwd {
          margin-top: 6px;
          margin-bottom: 6px;
          > input {
            width: 175px;
          }
        }
        &.code {
          margin-bottom: 13px;
          > input {
            width: 130px;
          }
          .getCode {
            display: flex;
            align-items: center;
            color: $primary-color;
            border-left: 1px solid $primary-color;
            padding-left: 10px;
            height: 25px;
            font-size: $font-nm;
          }
        }
      }
      .redirect {
        display: flex;
        color: $primary-color-1;
        justify-content: space-between;
        width: 222px;
        margin: auto;
        font-size: $font-nm;
        > span {
          padding: 6px 11px 11px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
      .agree {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        color: #999999;
        margin-top: 8px;
        > img {
          width: 8px;
          height: 8px;
          margin-right: 5px;
          margin-top: 1px;
        }
      }
    }
  }
}
</style>